import type { ListItemProps, TypographyProps } from '@mui/material'
import { ListItemIcon, ListItemText, MenuItem, Typography } from '@mui/material'
import { Mixer } from '@tunasong/icons'
import { Dialog } from '@tunasong/ui-lib'
import React, { useState } from 'react'
import { AudioMixer } from './audio-mixer.js'

export interface MixerMenuItemProps extends Omit<ListItemProps, 'button'> {
  variant?: TypographyProps['variant']
  onClose?: () => void
}

export const useMixerMenuItem = (props: MixerMenuItemProps = {}) => {
  const { onClose, onClick, variant = 'body1', ...restProps } = props

  const [showMixer, setShowMixer] = useState(false)
  const handleShowMixer = (ev: React.MouseEvent<HTMLLIElement>) => {
    ev.preventDefault()
    if (onClick) {
      onClick(ev)
    }
    setShowMixer(true)
  }
  const handleHideMixer = () => {
    setShowMixer(false)
    if (onClose) {
      onClose()
    }
  }

  return {
    dialog: (
      <Dialog fullScreen open={showMixer} onClose={handleHideMixer} title="Mixer" fullWidth={true} maxWidth="sm">
        <AudioMixer />
      </Dialog>
    ),
    menuItem: (
      <MenuItem title="Mixer" onClick={handleShowMixer} {...restProps}>
        <ListItemIcon sx={{ color: 'inherit' }}>
          <Mixer />
        </ListItemIcon>
        <ListItemText>
          <Typography variant={variant}>Mixer</Typography>
        </ListItemText>
      </MenuItem>
    ),
  }
}
